var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-map"},[_c('div',{ref:"googleMap",staticClass:"google-map__map"}),(Boolean(_vm.google) && Boolean(_vm.map))?_vm._t("marker",null,{"google":_vm.google,"map":_vm.map}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }